'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgActionMoveToFolder = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M6 13h8.86l-2.52 3h2.61l3.36-4-3.37-4h-2.61l2.52 3H6v2Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "m12.47 4-1.26-1.5H2V16h2V4.5h6.27L11.53 6H20v12H2v2h20V4h-9.53Z" })
);

module.exports = SvgActionMoveToFolder;
//# sourceMappingURL=ActionMoveToFolder.cjs.js.map
